import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { IMobileSecuritySetting } from '../types/IMobileSecuritySettings';

export interface ISetMobileSecuritySettingsForSiteSettingsParams {
  siteId: string;
  settings: IMobileSecuritySetting[];
}

export type ISetMobileSecuritySettingsForSiteSettingsResult = IResult;

export class SetMobileSecuritySettingsForSiteRequest extends Request<ISetMobileSecuritySettingsForSiteSettingsParams, ISetMobileSecuritySettingsForSiteSettingsResult> {
  constructor(params: ISetMobileSecuritySettingsForSiteSettingsParams) {
    super('setMobileSecuritySettingsForSite', params);
  }
}
